import { listenUser } from '../../models/Identity';
import BaseTenantComponent from './BaseTenantComponent';

export default class BaseUserComponent<P = {}, S = {}> extends BaseTenantComponent<P, S> {
    componentDidMount(): void {
        super.componentDidMount.apply(this);

        this._unlisten.push(listenUser(() => this.forceUpdate()));
    }
}